

































import Vue from 'vue';

export default Vue.extend({
  name: 'HMStudioHeader',
  props: {
    image: {
      type: Object,
    },
    profilePhoto: {
      type: String,
    },
    allowEmptyImage: {
      type: Boolean,
      default: false,
    },
    profilePosition: {
      type: String,
      default: 'float',
    },
  },
  computed: {
    imageUrl() {
      return this.image?.image_url;
    },
    studioHeaderImageStyle() {
      if (!this.image) {
        return {};
      }
      const { focal_point_x, focal_point_y } = this.image;
      return {
        objectPosition: `${focal_point_x}% ${focal_point_y}%`,
      };
    },
  },
});
